import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../store/store';
import { logout, getWebSocketInstance } from '../store/slices/userSlice';
import { postLogoutDataCleanup } from '../store/slices/dataSlice';
import { clearAllCache } from '../utils/cache';
import logger from '../utils/logger';
import DataGridWebSocketService from '../api/services/data-grid-websocket-service';

const UserProfile: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loggedInUser } = useSelector((state: RootState) => state.user);

  const handleLogout = () => {
    logger.debug('User logging out');
    
    // Send logout request to WebSocket server
    if (loggedInUser) {
      const ws = getWebSocketInstance();
      const logoutPayload = ws.buildLogoutRequest(loggedInUser);
      DataGridWebSocketService.sendMessage(logoutPayload.serializeBinary());
    }
    
    // Clear cache
    clearAllCache();
    
    // Dispatch logout action
    dispatch(logout());
    
    // Clear all data (trades, market data, strategies)
    dispatch(postLogoutDataCleanup());
    
    // Navigate to login page
    navigate('/');
  };

  if (!loggedInUser) {
    return null;
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      marginLeft: 'auto',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#e0e0e0',
        fontSize: '14px',
      }}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        <span style={{ fontWeight: '500' }}>{loggedInUser.username}</span>
      </div>
      
      <button
        onClick={handleLogout}
        style={{
          padding: '6px 16px',
          backgroundColor: '#d32f2f',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: '500',
          transition: 'background-color 0.2s',
          marginTop: '5px',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#b71c1c';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#d32f2f';
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default UserProfile;

